export const integratorsKeys = {
  all: ['integrators'] as const,
  publicList: () => [...integratorsKeys.all, 'public-list'] as const,
  adminList: () => [...integratorsKeys.all, 'admin-list'] as const,
  // Sessions no se cachean con TanStack — son single-use y TTL 2min. Se
  // consumen con `useMutation` en el IntegratorFrame.
};
